<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">在研课题汇总</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-form ref="queryFormRef" :model="queryForm" label-width="0px">
											<el-row :gutter="10">
												<el-col :span="3">
													<el-form-item><el-input placeholder="课题名称,负责人,学校" v-model="queryForm.keyWord"></el-input></el-form-item>
												</el-col>
												
												<el-col :span="3">
													<el-form-item>
														<el-cascader
															v-model="queryForm.keywordId"
															:options="topicLevelTypeList"
															:show-all-levels="false"
															:props="{ checkStrictly: true, label: 'name', value: 'id' }"
															clearable
														></el-cascader>
													</el-form-item>
												</el-col>
												
												<el-col :span="3">
													<el-form-item>
														<el-select v-model="queryForm.learningType" clearable placeholder="所属学段">
															<el-option v-for="item in learningTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
														</el-select>
													</el-form-item>
												</el-col>
												
												<el-col :span="3">
													<el-form-item>
														<el-select v-model="queryForm.disciplineId" clearable placeholder="所属学科">
															<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
														</el-select>
													</el-form-item>
												</el-col>
												
												<el-col :span="3">
													<el-form-item><el-date-picker v-model="queryForm.year" value-format="yyyy" type="year" placeholder="立项年度"></el-date-picker></el-form-item>
												</el-col>
												
												<el-col :span="6">
													<el-form-item>
														<el-button type="primary" @click="queryTopic">查询</el-button>
														<el-button type="success" @click="exportExcel">导出Excel</el-button>
													</el-form-item>
												</el-col>
												
											</el-row>
										</el-form>

										<div class="data_sum mb20">{{ underStudyTopicStat }}</div>
										<el-table
											id="table"
											:header-cell-style="tableStyle"
											border
											:data="topicSumData"
											@selection-change="topicSumSelectionChange"
											style="width: 100%;margin-bottom: 20px;"
										>
											<!-- <el-table-column type="selection" width="55" :selectable="isCanBeSelect"></el-table-column> -->
											<el-table-column v-if="userinfo.roleId.indexOf('5') != -1" type="selection" width="55"></el-table-column>
											<el-table-column prop="projectNumber" label="立项编号" width="100"></el-table-column>
											<el-table-column prop="declareName" label="课题名称" width="180"></el-table-column>
											<el-table-column prop="projectTypeName" label="课题类别"></el-table-column>
											<el-table-column prop="learningTypeName" label="学段"></el-table-column>
											<el-table-column prop="disciplineName" label="学科"></el-table-column>
											<el-table-column prop="oneUnitName" label="单位"></el-table-column>
											<el-table-column prop="oneEmceeName" label="负责人"></el-table-column>
											<el-table-column prop="expectedClosingTime" label="预结题时间">
												<template v-slot:default="scope">
													{{ scope.row.expectedClosingTime | getTime }}
												</template>
											</el-table-column>
											<el-table-column prop="status" label="当前阶段">
												<template v-slot:default="scope">
													{{ scope.row.status | getTopicStage }}
												</template>
											</el-table-column>
											<el-table-column v-if="userinfo.roleId.indexOf('5') != -1" prop="" label="操作" width="140">
												<template v-slot:default="scope">
													<el-button-group v-if="scope.row.type == 1">
														<el-button size="mini" type="primary" @click="goAddTopicPage('edit', scope.row)">修改</el-button>
														<el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
													</el-button-group>
												</template>
											</el-table-column>
										</el-table>
										<div class="btn_wrap" v-if="userinfo&&userinfo.roleId.indexOf('9') != -1">
											<el-button style="margin-right: 20px;" type="primary" @click="goAddTopicPage('add')">创建课题</el-button>
											<div>
												<el-select v-model="jumpForm.type" placeholder="请选择" style="width: 150px;">
													<el-option v-for="item in jumpOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<el-button style="margin-left: 20px;" type="primary" @click="jumpProcess">更改课题阶段</el-button>
											</div>
										
											<!-- <el-button type="primary" @click="goAddTopicPage('edit')">修改</el-button>
											<el-button type="danger" @click="del">删除</el-button> -->
										</div>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="queryForm.pageNumber"
												:page-sizes="[ 50, 100,200]"
												:page-size="queryForm.pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
										
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getUnderStudyTopicList, createOrEditUnderStudyTopic, delUnderStudyTopic, underStudyTopicStat, jumpProcess,getUserLearningSection } from '@/api/after/topicManage.js';
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			jumpForm: {
				ids: [], //课程管理id集合
				type: 1 //跳转节点类型(1:中期,2:结题申请,3:结题)
			},
			jumpOptions: [
				{
					label: '中期',
					value: 1
				},
				{
					label: '结题',
					value: 3
				}
			],
			underStudyTopicStat: '', //在研课题汇总文字统计
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			queryForm: {
				disciplineId: '',
				keyWord: '',
				keywordId: '',
				learningType: '',
				pageNumber: 1,
				pageSize: 20,
				year: ''
			},
			topicLevelTypeList: [], //课题级别类别列表
			// 学段列表
			learningTypeList: [
				{
					value: 0,
					label: '幼儿园'
				},
				{
					value: 1,
					label: '小学'
				},
				{
					value: 2,
					label: '初中'
				},
				{
					value: 3,
					label: '高中'
				},
				{
					value: 4,
					label: '高/中职'
				},
				{
					value: 5,
					label: '其他'
				}
			],
			// 学科列表
			disciplineOptions: [],
			options: [],
			topicSumData: [], //在研课题列表
			underStudyTopicTotal: 0,
			topicSumSelectionList: [] ,//多选在研课题
			userinfo:JSON.parse(sessionStorage.getItem('userInfo'))//获取当前用户信息
		};
	},
	created() {
		this.getTopicLevelTypeList();
		this.getDiscipline();
		this.getUnderStudyTopicList();
		this.getUnderStudyTopicStat();
		// this.filterLearning();
		this.getUserLearningSection()
		
	},
	methods: {
		// 过滤学段
		// filterLearning(){
		// 	if(this.userinfo.roleId.indexOf('2')!=-1 ||this.userinfo.roleId.indexOf('5')!=-1 ){
        //         let array=this.learningTypeList.filter((item,index)=>{
		// 			if(this.userinfo.learningSection.indexOf(item.value.toString())!=-1){
		// 				return item
		// 			}
		// 		})
		// 		this.learningTypeList=array
		// 	}else{
        //        this.learningTypeList=[
		// 		{
		// 			value: 0,
		// 			label: '幼儿园'
		// 		},
		// 		{
		// 			value: 1,
		// 			label: '小学'
		// 		},
		// 		{
		// 			value: 2,
		// 			label: '初中'
		// 		},
		// 		{
		// 			value: 3,
		// 			label: '高中'
		// 		},
		// 		{
		// 			value: 4,
		// 			label: '高/中职'
		// 		},
		// 		{
		// 			value: 5,
		// 			label: '其他'
		// 		}
		// 	]
		// 	}
		// },
		async getUserLearningSection(){
			const res= await getUserLearningSection()
			if(res.code==200){
				// console.log(res.data);
				let array=this.learningTypeList.filter((item,index)=>{
					if(res.data!==null){
						if(res.data.indexOf(item.value.toString())!=-1){
						// console.log(item);
						return item
					}
					}else{

					}
				})
				this.learningTypeList=array
			}
		},
		async jumpProcess() {
			if (!this.topicSumSelectionList.length) {
				this.$message.warning('请选择需要跳转流程的课题！');
				return;
			}
			if (this.hasWrongTopic()) {
				this.$message.error('请先手动取消处于结题校审核未处理阶段之后的课题！');
				return;
			}
			let ids = this.topicSumSelectionList.map(item => {
				return item.id;
			});
			this.jumpForm.ids = ids;
			console.log(this.jumpForm);
			const res = await jumpProcess(this.jumpForm);
			if (res.code == 200) {
				this.$message.success('流程跳跃成功！');
				this.getUnderStudyTopicList();
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取在研课题汇总统计
		async getUnderStudyTopicStat() {
			const res = await underStudyTopicStat();
			if (res.code == 200) {
				console.log('在研课题汇总统计', res);
				this.underStudyTopicStat = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 导出Excel列表
		exportExcel() {
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '在研课题汇总.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		// 删除在研课题
		del(id) {
			// if (this.topicSumSelectionList.length>1) {
			// 	this.$message.error('一次只能删除一个在研课题！')
			// 	return
			// }
			// if (this.topicSumSelectionList.length === 0) {
			// 	this.$message.error('请选择要删除的课题！')
			// 	return
			// }
			// this.delUnderStudyTopic(this.topicSumSelectionList[0].id)
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.delUnderStudyTopic(id);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		// 搜索在研课题
		queryTopic() {
			this.queryForm.pageNumber = 1;
			this.getUnderStudyTopicList();
		},
		// 跳转到创建课题页面
		goAddTopicPage(type, data) {
			if (type == 'add') {
				this.$router.push('/backstage/addOrEditTopic');
			} else if (type == 'edit') {
				// if (this.topicSumSelectionList.length>1) {
				// 	this.$message.error('一次只能修改一个在研课题！')
				// 	return
				// }
				// if (this.topicSumSelectionList.length == 0) {
				// 	this.$message.error('请选择要修改的课题！')
				// 	return
				// }
				let query = {
					// data:encodeURIComponent(JSON.stringify(this.topicSumSelectionList[0]))
					data: encodeURIComponent(JSON.stringify(data))
				};
				this.$router.push({ path: '/backstage/addOrEditTopic', query });
			}
		},
		// 表格是否可选
		isCanBeSelect(row, index) {
			if (row.type == 1) {
				return true;
			} else {
				return false;
			}
		},
		// 创建课题
		topicSumSelectionChange(val) {
			this.topicSumSelectionList = val;
			if (this.hasWrongTopic()) {
				this.$message({
					type: 'error',
					message: '你选择的课题中含有不可进行流程跳转的课题！'
				});
			}
		},
		// 判断选择的课题中是否有不能流程跳跃的课题
		hasWrongTopic() {
			let hasWrongData = this.topicSumSelectionList.some(item => {
				return item.status >= 16;
			});
			return hasWrongData;
		},
		// 获取在研课题列表
		async getUnderStudyTopicList() {
			let params = JSON.parse(JSON.stringify(this.queryForm));
			// 处理课题级别类别数据
			if (params.keywordId) {
				if (params.keywordId.length) {
					params.keywordId = params.keywordId[params.keywordId.length - 1];
				} else {
					params.keywordId = '';
				}
			}
			const res = await getUnderStudyTopicList(params);
			if (res.code == 200) {
				this.topicSumData = res.data.records;
				this.underStudyTopicTotal = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		// 删除在研课题
		async delUnderStudyTopic(id) {
			const res = await delUnderStudyTopic(id);
			if (res.code == 200) {
				this.$message.success('删除成功！');
				this.getUnderStudyTopicList();
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取课题级别类别目录
		async getTopicLevelTypeList() {
			const res = await getPlatformInformationData(1);
			console.log('课题级别类别', res);
			if (res.code == 200) {
				this.topicLevelTypeList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(8);
			if (res.code == 200) {
				this.disciplineOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		handleSizeChange(val) {
			this.queryForm.pageSize = val;
			this.getUnderStudyTopicList();
		},
		handleCurrentChange(val) {
			this.queryForm.pageNumber = val;
			this.getUnderStudyTopicList();
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
</style>
